import axios from 'axios';
import config from '../config'
import qs from 'qs';
let zaApi = config.API_ROOT;
const cmsApi = config.API_CMS;
import {getNow, randomString} from '../utils/tool'

import storage from '../utils/storage'
// 环境变量
let host=window.location.host
console.log(config,'config');
if(config.ENV=='-test' && host=='one-test.zhongan.com'){
    if(storage.get('ENV_API')){
        zaApi = storage.get('ENV_API')
    }
}


export const api = (data) => {
    let method = data.method || 'post';
    //公共参数
    var p = Object.assign({}, {
        'channel': '1',
        'partnerNo': 'NYDDXJD',
        'thirdUserNo': '1',
        'userId':'1',
        'reqNo': randomString(20),
        'reqDate': getNow(),
        'apiVersion': '1.0.0',
        'accessKey': '1'
    }, data.param)
    data.param = JSON.stringify(p);
    //qs序列化数据 编码
    return new Promise((resolve, reject) => {
        axios[method](zaApi, qs.stringify(data)).then((response) => {
            resolve(response)
        }).catch((error) => {
            reject(error)
        })
    });
}

export const ddcms = (data) => {
    let method = data.method || 'post';
    //公共参数
    var p = Object.assign({}, {
        'partnerNo': 'NYDDXJD',
        'reqNo': randomString(20),
        'reqDate': getNow(),
        'apiVersion': '1.0.0',
    }, data.param)
    data.param = JSON.stringify(p);
    //qs序列化数据 编码
    return new Promise((resolve, reject) => {
        axios[method](cmsApi, qs.stringify(data)).then((response) => {
            resolve(response)
        }).catch((error) => {
            reject(error)
        })
    });
}

export const apiRsa = (data) => {
    let method = data.method || 'post';
    //公共参数
    var p = Object.assign({}, {
        'channel': '1',
        'partnerNo': 'NYDDXJD',
        'thirdUserNo': '1',
        'userId':'1',
        'reqNo': '1',
        'reqDate': '2017-10-01 00:00:00',
        'apiVersion': '1.0.0',
        'accessKey': '1'
    }, data.param)
    //Rsa
    data.param =Rsa(JSON.stringify(p));
    //qs序列化数据 编码
    return new Promise((resolve, reject) => {
        axios[method](zaApi,qs.stringify(data)).then((response) => {
            resolve(response)
        }).catch((error) => {
            reject(error)
        })
    });
}



// WEBPACK FOOTER //
// ./src/api/axios.js